import { ExpandedSettingsState, SettingsCategoryKey } from './types';

export const SETTINGS_CATEGORY_KEYS: SettingsCategoryKey[] = [
  'callLifecycle',
  'idleAndCustomer',
  'whatsapp',
  'callRouting',
  'voiceAnalysis',
  'integrations',
];

// Keep validation ownership explicit: RHF errors need to be mapped back to the
// tab containing their fields. This preserves deterministic first-error navigation.
export const SETTINGS_CATEGORY_FORM_FIELDS = {
  callLifecycle: [
    'callbackRequestTool.enabled',
    'voiceMailDetectionTool.enabled',
    'endCallTool.enabled',
  ],
  idleAndCustomer: [],
  whatsapp: [
    'sendFollowUpMessageTool.enabled',
    'sendFollowUpMessageTool.messageTemplate',
    'generateWhatsappMessageTool.enabled',
  ],
  callRouting: [
    'transferTool.enabled',
    'transferTool.phoneNumbers',
    'callHandoffSignalTool.enabled',
  ],
  voiceAnalysis: [
    'genderDetectionTool.enabled',
    'genderDetectionTool.confidenceThreshold',
    'genderDetectionTool.durationThreshold',
    'genderDetectionTool.behaviorTemplate',
  ],
  integrations: [],
} as const;

export const createExpandedSettingsState = (enabled: boolean): ExpandedSettingsState => ({
  idle: enabled,
  customerIdle: enabled,
  whatsapp: enabled,
  transfer: enabled,
  gender: enabled,
});
